import { handleActions } from 'redux-actions';

import { types, companyStatus } from '../constants';

const INITIAL_STATE = {
  allCompanies: {
    items: [],
    itemsCopy: [],
    isLoading: false,
    errorMessage: '',
    searchTerm: ''
  }
};

const changeSearchTermForAllCompanies = (state, { searchTerm }) => {
  let companies = state.allCompanies.itemsCopy;

  let filteredCompanies = companies.filter(
    (g) =>
      (g.name && g.name.toLowerCase().includes(searchTerm)) ||
      (g.email && g.email.toLowerCase().includes(searchTerm))
  );

  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      searchTerm,
      items: filteredCompanies
    }
  };
};

const startFetchAllCompanies = (state) => {
  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      isLoading: true
    }
  };
};

const fetchAllCompaniesSuccess = (state, { allCompanies }) => {
  const activeCompanies = allCompanies.filter(
    (c) => c.status === companyStatus.ACTIVE
  );
  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      items: activeCompanies,
      itemsCopy: activeCompanies
    }
  };
};

const fetchAllCompaniesFailure = (state, { errorMessage }) => {
  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      errorMessage
    }
  };
};

const fetchAllCompaniesFinished = (state) => {
  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      isLoading: false
    }
  };
};

const submitCompanySuccess = (state, { submittedCompany }) => {
  let companies = [...state.allCompanies.items];
  let updatedCompanyIndex = companies.findIndex(
    (c) => c.id === submittedCompany.id
  );

  //Means updated
  if (updatedCompanyIndex !== -1) {
    companies[updatedCompanyIndex] = submittedCompany;
  }
  //Means newly created
  else {
    companies = [...companies, submittedCompany];
  }

  return {
    ...state,
    allCompanies: {
      ...state.allCompanies,
      items: companies,
      itemsCopy: companies
    }
  };
};

//Handles the incoming actions.
export default handleActions(
  {
    [types.CHANGE_SEARCH_TERM_ALL_COMPANIES]: changeSearchTermForAllCompanies,

    [types.START_FETCH_ALL_COMPANIES]: startFetchAllCompanies,
    [types.FETCH_ALL_COMPANIES_SUCCESS]: fetchAllCompaniesSuccess,
    [types.FETCH_ALL_COMPANIES_FAILURE]: fetchAllCompaniesFailure,
    [types.FETCH_ALL_COMPANIES_FINISHED]: fetchAllCompaniesFinished,

    [types.SUBMIT_COMPANY_SUCCESS]: submitCompanySuccess
  },
  INITIAL_STATE
);
